import Vue from 'vue'

// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Icon from '@kvass/vue2-icon'
Vue.component('FontAwesomeIcon', Icon)
Vue.component('Icon', Icon)

import { ButtonComponent } from 'vue-elder-button'
Vue.component('ButtonComponent', ButtonComponent)

import { LoaderComponent as Loader, setup as LoaderSetup } from 'vue-elder-loader'
LoaderSetup({
  theme: 'overlay',
  icon: { icon: ['fal', 'spinner-third'], size: '2x' },
  delay: 200,
})
Vue.component('Loader', Loader)

import TourTrigger from '@/components/TourTrigger/TourTrigger.vue'
Vue.component('Tour', TourTrigger)

import { setup as CustomFieldsSetup } from '@kvass/custom-fields'
import Directories from '@kvass/directories'
import ProjectList from '@/components/CustomFields/ProjectList'
CustomFieldsSetup({
  components: [Directories, ProjectList]
})

//install as global to use in vue-elder-navigation
import Actions from '@/components/Actions'
Vue.component('ActionsComponent', Actions)

// Imports for style reasons - if ommitted some styles are missing -> Do not remove
import Badge from '@/components/Badge'
